/*
 *
 * Do not edit directly
 * Generated on Fri, 11 Jul 2025 22:14:40 GMT
 *
 */


const theme = {
  appearances: {
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    selected: {
      description: 'Applies while an interactive component is the currently selected one in a set of states or components, for example a button in a `ButtonGroup`.',
      type: 'state',
      values: [ true ]
    },
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { viewport: [ 'lg', 'xl' ] },
      tokens: { direction: 'row', space: 5 }
    },
    {
      if: { viewport: [ 'xs', 'sm', 'md' ] },
      tokens: { direction: 'column', fieldSpace: 3, space: 3 }
    }
  ],
  tokens: {
    borderBottomLeftRadius: 1,
    borderBottomRightRadius: 1,
    borderTopLeftRadius: 1,
    borderTopRightRadius: 1,
    direction: 'column',
    fieldSpace: 3,
    outlineOffset: 8,
    outlineWidth: 1,
    paddingBottom: 24,
    paddingLeft: 24,
    paddingRight: 24,
    paddingTop: 24,
    showIcon: true,
    space: 3
  }
}
export default theme
